import React from 'react';
import GreyableButton, { GreyableButtonProps } from './GreyableButton';

const SmallButton = ({ className, ...rest }: GreyableButtonProps) => {
  return <GreyableButton className={'text-sm px-5 ' + className} {...rest}></GreyableButton>;
};

export default SmallButton;
